// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ceead5d0] .guest-status-cell .guest-status-image{width:25px;height:25px;margin-right:.5rem}", ""]);
// Exports
module.exports = exports;
